<template>
<div class="chapter">
<div class="inner_page">
      ﻿


<link href="styles/default.css" rel="stylesheet" type="text/css"/>
<title>Aunt Bee’s Delightful Desserts: More Than 350 Recipes from Mayberry, Americas’s Friendliest Town</title>
<p class="ctr" id="pz16-2"><a href="#/contents#RR_13" id="CC_13"> Mayberry Hospitality Lemonade</a></p>
<p class="tx6" id="pz16-3"><i> The friendly tonic. </i></p>
<p class="tx5" id="pAM-b"><b> 1¼ cups sugar </b></p>
<p class="tx5" id="pA4k"><b> ½ cup boiling water </b></p>
<p class="tx5" id="pACj"><b> 1½ cups fresh lemon juice </b></p>
<p class="tx5" id="pAgND"><b> 4½ cups water </b></p>
<p class="tx1" id="pAXuy"><span class="dcap">P</span>our sugar into boiling water, stirring until sugar dissolves. Add lemon juice and cold water. Mix well. Serve over ice.</p>
<p class="tx" id="pAs0"> Makes 7 cups.</p>
<p class="txrr" id="pAFvZ"> <i>Alma Venable—Mount Airy, North Carolina</i></p>
<div class="box" id="A0dR">
<p class="tx1a" id="pA2r"><i>A sucker for a snowcone:</i></p>
<table id="pAysm">
<tbody id="Aysm" style="vertical-align: top;">
<tr id="tr-Aysm-0">
<td id="td-Aysm-0-0"><p class="txtb">BARNEY:</p></td>
<td id="td-Aysm-0-1">Boy, if I knew then what I know now. She used to do one thing that really used to burn me up.</td>
</tr>
<tr id="tr-Aysm-1">
<td id="td-Aysm-1-0"><p class="txtb">ANDY:</p></td>
<td id="td-Aysm-1-1">What was that?</td>
</tr>
<tr id="tr-Aysm-2">
<td id="td-Aysm-2-0"><p class="txtb">BARNEY:</p></td>
<td id="td-Aysm-2-1">You know how I like snowcones.</td>
</tr>
<tr id="tr-Aysm-3">
<td id="td-Aysm-3-0"><p class="txtb">ANDY:</p></td>
<td id="td-Aysm-3-1">Raspberry.</td>
</tr>
<tr id="tr-Aysm-4">
<td id="td-Aysm-4-0"><p class="txtb">BARNEY:</p></td>
<td id="td-Aysm-4-1">Right. Well, there wasn’t a day went by that I didn’t offer that girl a bite of my snowcone. You know what she used to do every single time?</td>
</tr>
<tr id="tr-Aysm-5">
<td id="td-Aysm-5-0"><p class="txtb">ANDY:</p></td>
<td id="td-Aysm-5-1">What?</td>
</tr>
<tr id="tr-Aysm-6">
<td id="td-Aysm-6-0"><p class="txtb">BARNEY:</p></td>
<td id="td-Aysm-6-1">She used to bite off the end, sip out all the syrup, and leave me with nothing but the ice.</td>
</tr>
<tr id="tr-Aysm-7">
<td id="td-Aysm-7-0"><p class="txtb">ANDY:</p></td>
<td id="td-Aysm-7-1">The ice?</td>
</tr>
<tr id="tr-Aysm-8">
<td id="td-Aysm-8-0"><p class="txtb">BARNEY:</p></td>
<td id="td-Aysm-8-1">Yeah, the ice.</td>
</tr>
<tr id="tr-Aysm-9">
<td id="td-Aysm-9-0"><p class="txtb">ANDY:</p></td>
<td id="td-Aysm-9-1">That’s terrible. Today you’d know different.</td>
</tr>
<tr id="tr-Aysm-10">
<td id="td-Aysm-10-0"><p class="txtb">BARNEY:</p></td>
<td id="td-Aysm-10-1">Ha, are you kidding?! Listen, if I had a date with Vicky Harmes today and I got myself all shaved and I went over to her house with my snowcone, you know what I’d do?</td>
</tr>
<tr id="tr-Aysm-11">
<td id="td-Aysm-11-0"><p class="txtb">ANDY:</p></td>
<td id="td-Aysm-11-1">What?</td>
</tr>
<tr id="tr-Aysm-12">
<td id="td-Aysm-12-0"><p class="txtb">BARNEY:</p></td>
<td id="td-Aysm-12-1">The minute she opened that door I’d bite off the end of the cone, sip out the syrup, and hand her the cone. What do you think of that?</td>
</tr>
<tr id="tr-Aysm-13">
<td id="td-Aysm-13-0"><p class="txtb">ANDY:</p></td>
<td id="td-Aysm-13-1">Well, I’ll tell you the truth, Barn. If I was Vicky Harmes and a 35-year-old man come up to my house with a snowcone in his hands, I wouldn’t even answer the door.</td>
</tr>
</tbody>
</table></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter13.vue?5f5937ab